import React from 'react';
import { MailIcon, StarIcon } from 'lucide-react';
interface Review {
  name: string;
  city: string;
  email: string;
  text: string;
}
const reviews: Review[] = [{
  name: 'Carlos Martín',
  city: 'Madrid',
  email: 'carlos.martin••@gmail.com',
  text: 'El tomo de salida de balón me ayudó a jugar mucho más tranquilo cuando me vienen a presionar. Ahora sé dónde perfilarme y cuándo girar.'
}, {
  name: 'Sergio López',
  city: 'Málaga',
  email: 'sergio.lopez••@gmail.com',
  text: 'Muy claro, directo y aplicable desde el primer entrenamiento. El apartado físico está muy bien explicado y ya lo estoy usando.'
}, {
  name: 'Álvaro Ruiz',
  city: 'Valencia',
  email: 'alvaro.ruiz••@gmail.com',
  text: 'Por fin entendí dónde colocarme cuando el equipo pierde el balón. Recomendadísimo para mediocentros que juegan amateur.'
}, {
  name: 'David Ortega',
  city: 'Sevilla',
  email: 'david.ortega••@gmail.com',
  text: 'Los ejemplos tácticos hacen que sea muy fácil llevarlo al campo. Se nota la diferencia en los partidos desde la primera semana.'
}];
export function SocialProofCarousel() {
  return <section className="mb-10 mt-7" aria-labelledby="social-proof-title" data-id="element-204" data-mp="4p8rn7shnk6u">
      <div className="mx-auto mb-5 flex max-w-md items-center justify-center overflow-hidden rounded-2xl border border-green-200 bg-white text-left shadow-sm" data-id="element-205" data-mp="m2q2dgbmh6p">
        <div className="flex min-w-0 flex-1 items-center gap-3 bg-green-50 px-4 py-3" data-id="element-206" data-mp="sd8j69xmjemh">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-green-700 text-sm font-black text-white" data-id="element-207" data-mp="obdldfewjjdg">
            +550
          </div>
          <div className="min-w-0" data-id="element-208" data-mp="ji2a92324gfq">
            <p id="social-proof-title" className="text-sm font-black leading-tight text-green-900" data-id="element-209" data-mp="eltxfvcc0zbq">
              jugadores de España
            </p>
            <p className="mt-0.5 text-xs font-semibold text-green-700" data-id="element-210" data-mp="1c20xkcvuov5t">Ya entrenan su rol de pivote</p>
          </div>
        </div>
        <div className="flex flex-col items-center border-l border-green-200 px-4 py-3" aria-label="Valoración de 4.9 sobre 5" data-id="element-211" data-mp="1q6hy38n0vjp4">
          <span className="text-lg font-black leading-none text-gray-900" data-id="element-212" data-mp="1v49otzbxkzrq">4.9/5.</span>
          <div className="mt-1 flex gap-0.5 text-yellow-500" data-id="element-213" data-mp="1hefy1bgv85fd">
            {[...Array(5)].map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-214" data-mp="1leget2rfsspl" data-mpi={index} />)}
          </div>
        </div>
      </div>

      <div aria-label="Capturas de correos de jugadores de España" className="-mx-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-215" data-mp="17hti913ec4k7">
        {reviews.map(review => <article key={`${review.name}-${review.city}`} className="w-[86vw] max-w-[350px] flex-none snap-center rounded-2xl border border-gray-200 bg-[#f5f6f7] p-2 text-left shadow-md" data-id="element-216" data-mp="12hoxgyvggno6">
            <div className="overflow-hidden rounded-xl border border-gray-200 bg-white" data-id="element-217" data-mp="2wtvmp1l6p4zh">
              <div className="flex items-center border-b border-gray-100 bg-[#fafafa] px-3 py-2" data-id="element-218" data-mp="l7uslr2ko0kf">
                <MailIcon className="h-4 w-4 text-[#ea4335]" aria-hidden="true" data-id="element-219" data-mp="h7aw8pptp0zc" />
                <span className="ml-auto h-1.5 w-1.5 rounded-full bg-green-500" aria-hidden="true" data-id="element-220" data-mp="uy67u9rphw6m" />
              </div>

              <div className="p-4" data-id="element-221" data-mp="q4v2kd2jlngt">
                <p className="mb-4 text-base font-semibold leading-snug text-gray-900" data-id="element-222" data-mp="14vak9hvr2da8">
                  Re: Manual del Pivote Moderno
                </p>
                <div className="mb-4 flex items-start gap-3" data-id="element-223" data-mp="zvpm39oem8yk">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-green-700 text-sm font-black text-white" data-id="element-224" data-mp="1dwijc263bi5d">
                    {review.name.charAt(0)}
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-225" data-mp="3foesj54scfwz">
                    <p className="truncate text-sm font-bold text-gray-900" data-id="element-226" data-mp="3fp6owi67ihob">{review.name}</p>
                    <p className="truncate text-xs text-gray-500" data-id="element-227" data-mp="3aqn2yhrm55vy">{review.email}</p>
                    <p className="mt-0.5 text-[11px] text-gray-400" data-id="element-228" data-mp="3d2nybk0w3sod">Mensaje recibido hoy</p>
                  </div>
                </div>

                <div className="border-y border-gray-100 py-4" data-id="element-229" data-mp="3m3viyzahguzz">
                  <p className="mb-2 text-sm font-semibold text-gray-800" data-id="element-230" data-mp="3m1j26pggoqoi">Hola, soy de {review.city}.</p>
                  <p className="text-sm leading-relaxed text-gray-700" data-id="element-231" data-mp="3r0m6g7omasvf">{review.text}</p>
                </div>

                <p className="mt-3 text-right text-xs font-medium text-gray-400" data-id="element-232" data-mp="2td3pi9ksykgc">Enviado desde Gmail</p>
              </div>
            </div>
          </article>)}
      </div>
      <p className="mt-1 text-center text-xs font-semibold text-gray-500" data-id="element-233" data-mp="33bt5txx1vwuh">
        Desliza para ver más correos →
      </p>
    </section>;
}